<template>
		<div class="page">

			<el-container>
				<el-header class="homeHeader" height="90px">
          <el-image src="/images/bhsenslogoclear.png" alt="Logo" class="logo"></el-image>
          <el-button type="text"></el-button>
					<div class="title">{{ $t('home.home_title') }}</div>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button type="text"></el-button>
					<el-button class="lang-zh" @click="lang_zh" type="text" >中文</el-button>
					<el-button class="lang-en" @click="lang_en" type="text" >English</el-button>
          <el-button type="text"></el-button>
					<el-dropdown class="userInfo" @command="commandHandler" >
						<span class="el-dropdown-link">
							{{state}} {{user.username}}
							<i>
								<img :src="avatar" alt="" />
							</i>
							<i class="el-icon-arrow-down el-icon--right" style="margin-left: 10px;"></i>
						</span>
						
						<el-dropdown-menu slot="dropdown" style="width: 200px; height: 80px;">
							<center>
								<el-dropdown-item style="height: 50px; border-radius: 10px;" command="openMyInfo">{{$t('home.MyInfo')}}
								</el-dropdown-item>
								<el-dropdown-item style="height: 50px; border-radius: 10px;" command="logout">{{$t('home.logout')}}
								</el-dropdown-item>
							</center>
						</el-dropdown-menu>
					</el-dropdown>
					
				</el-header>

				<el-container>
					<!-- 导航栏 -->
					<el-aside width="210px">
						<el-menu @select="menuClick" class="el-menu-vertical-demo" background-color="#324157"
							text-color="#fff" active-text-color="#ffd04b">
							<el-menu-item :index="item.path" :key="index" class="item" v-for="(item,index) in routes"
								v-if="!item.hidden" style="margin-bottom: 15px; margin-top: 10px;">
								<i :class="item.icon" style="margin-right: 10px;"></i>
								<span slot="title" v-if="lang" style="font-size: 14px;">{{item.name_zh}}</span>
								<span slot="title" v-if="!lang" style="font-size: 14px;">{{item.name_en}}</span>
							</el-menu-item>
						</el-menu>
					</el-aside>

					<!-- 放入路由路径 -->
					<el-main>
						<el-breadcrumb separator-class="el-icon-arrow-right"
							v-if="this.$router.currentRoute.path != '/home'">
							<el-breadcrumb-item class="breadcrumbContainer" @click.native="goHome">{{$t('home.homepage')}}</el-breadcrumb-item>
							<el-breadcrumb-item v-if="this.$router.currentRoute.path == '/user'" style="font-size: 16px;">{{this.$t('usersmanage.usersmanagename')}}
							</el-breadcrumb-item>
							<el-breadcrumb-item v-if="this.$router.currentRoute.path == '/car'" style="font-size: 16px;">{{this.$t('carsmanage.carsmanagename')}}
							</el-breadcrumb-item>
							<el-breadcrumb-item v-if="this.$router.currentRoute.path == '/sensor'" style="font-size: 16px;">{{this.$t('sensorsmanage.sensorsmanagename')}}
							</el-breadcrumb-item>
							<el-breadcrumb-item v-if="this.$router.currentRoute.path == '/appLog'" style="font-size: 16px;">{{this.$t('applogmanage.applogmanagename')}}
							</el-breadcrumb-item>
							<el-breadcrumb-item v-if="this.$router.currentRoute.path == '/sysLog'" style="font-size: 16px;">{{this.$t('syslogmanage.syslogmanagename')}}
							</el-breadcrumb-item>
							<el-breadcrumb-item v-if="this.$router.currentRoute.path == '/adminLog'" style="font-size: 16px;">{{this.$t('adminlogmanage.adminlogmanagename')}}
							</el-breadcrumb-item>
							<el-breadcrumb-item v-if="this.$router.currentRoute.path == '/admin'" style="font-size: 16px;">{{this.$t('adminmanage.adminmanagename')}}
							</el-breadcrumb-item>
							<el-breadcrumb-item v-if="this.$router.currentRoute.path == '/file'" style="font-size: 16px;">{{this.$t('file.filename')}}
							</el-breadcrumb-item>
							<!-- <el-breadcrumb>
								<el-button @click="" type="text" style="width:5%;high:1%">中文</el-button>
								<el-button @click="" type="text" style="width:5%;high:1%">English</el-button>
							</el-breadcrumb> -->
						</el-breadcrumb>
						<div class="dashboard-container" style="margin-top: 0px;"
							v-if="this.$router.currentRoute.path == '/home'">
							<div class="dashboard-text">{{$t('home.home_welcome')}}</div>
							<el-row :gutter="20">
<!--								<el-col :span="8">-->
<!--									<div class="grid-content bg-purple">-->
<!--										<el-card shadow="hover" class="card">-->
<!--											<el-row>-->
<!--												<el-col :span="12">-->
<!--													<div class="grid-content bg-purple">-->
<!--														<el-image src="user.png"-->
<!--															class="icon"></el-image>-->
<!--													</div>-->
<!--												</el-col>-->
<!--												<el-col :span="12">-->
<!--													<div class="grid-content bg-purple">-->
<!--														<h2>{{$t('home.users')}}</h2>-->
<!--														<h3>{{userTotal}}</h3>-->
<!--													</div>-->
<!--												</el-col>-->
<!--											</el-row>-->
<!--										</el-card>-->
<!--									</div>-->
<!--								</el-col>-->
								<el-col :span="8">
									<div class="grid-content bg-purple">
										<el-card shadow="hover" class="card">
											<el-row>
												<el-col :span="12">
													<div class="grid-content bg-purple">
														<el-image src="admin.png"
															class="icon"></el-image>
													</div>
												</el-col>
												<el-col :span="12">
													<div class="grid-content bg-purple">
														<h2>{{$t('home.admins')}}</h2>
														<h3>{{adminTotal}}</h3>
													</div>
												</el-col>
											</el-row>
										</el-card>
									</div>
								</el-col>
<!--								<el-col :span="8">-->
<!--									<div class="grid-content bg-purple">-->
<!--										<el-card shadow="hover" class="card">-->
<!--											<el-row>-->
<!--												<el-col :span="12">-->
<!--													<div class="grid-content bg-purple">-->
<!--														<el-image src="car.png" class="icon"></el-image>-->
<!--													</div>-->
<!--												</el-col>-->
<!--												<el-col :span="12">-->
<!--													<div class="grid-content bg-purple">-->
<!--														<h2>{{$t('home.cars')}}</h2>-->
<!--														<h3>{{carTotal}}</h3>-->
<!--													</div>-->
<!--												</el-col>-->
<!--											</el-row>-->
<!--										</el-card>-->
<!--									</div>-->
<!--								</el-col>-->
							</el-row>
							<div class="chartLine_wrap">
								<div id="myChart" :style="{ width: '100%', height: '80%'}"></div>
							</div>
						</div>
						

						<!--  -->
						<router-view class="view-container" />
					</el-main>
				</el-container>
			</el-container>

			<!-- 密码修改框 -->
			<el-dialog title="Change Password" :visible.sync="cardialogFormVisible" width="500px">
				<el-form :model="adminForm">
					<el-form-item label="New Password">
						<el-input v-model="adminForm.password" autocomplete="off" @input="change($event)"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="cardialogFormVisible=false">Cancel</el-button>
					<el-button type="primary" @click="updateUserPwd()">Modify</el-button>
				</div>
			</el-dialog>
		</div>
	</template>


<script>
import { Console } from 'console';
// import * as echarts from "echarts";
// require("echarts/theme/macarons"); 
import * as ECharts from 'echarts'


export default {
		name: 'Home',
		computed: {
			routes() {
				console.log("routes " + this.$store.state.routes);
				return this.$store.state.routes;
			},
			lang(){
				console.log("lang " + this.chinese);
				return this.chinese;
			},
			avatorImg: {
				get(){
					return this.$store.state.imageUrl;
				},
				set(val){
					
				}
			}
		},
		watch:{
			avatorImg:{
				handler: function(val, oldVal){
					this.avatar = val;
				},
				immediate: true
			},
			lang(){
				console.log("lang " + this.chinese);
				return this.chinese;
			}
		},
		created: function() {
			let userInfo = window.localStorage.getItem("user");
      if(userInfo == null){
        this.getRequest("/tpa-api/admin/logout");
        // 删除用户数据
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("token");
        // 清空菜单
        this.$store.commit('initRoutes', []);
        // 跳转登录页
        this.$router.replace("/");
			}
			this.initData();
			this.initTotal();
			this.getTimeState();	
		},
		data() {
			return {
				user: JSON.parse(window.localStorage.getItem("user")),
				userTotal: 0,
				adminTotal: 0,
				carTotal: 0,
				adminForm: {
					password: ''
				},
				cardialogFormVisible: false,
				formDisabled: true,
				chinese:true,
				state: '',
				avatar: '',
				a: [],
				date: [],
				count: Object,
				temp:0,
			};
		},
		mounted() {
    	// this.searchData();
			// this.getDoubleLineData();
  		},
		methods: {
			lang_zh(){
				this.$i18n.locale = 'zh'
				this.getTimeState();
				console.log(this.$i18n.locale)
				this.chinese=true;
				console.log(this.chinese);
			},
			lang_en(){
				this.$i18n.locale = 'en'
				this.getTimeState();
				console.log(this.$i18n.locale)
				this.chinese=false;
				console.log(this.chinese);
			},
      getTimeState(){
			    // 获取当前时间
			    let timeNow = new Date();
			    // 获取当前小时
			    let hours = timeNow.getHours();
			    // 设置默认文字
			    let state= ``;
			    // 判断当前时间段
			    if (hours >= 0 && hours <= 10) {
			        state = this.$t('home.state1');
						} else if (hours > 10 && hours <= 13) {
			        state= this.$t('home.state2');
			    } else if (hours > 13 && hours <= 18) {
			        state= this.$t('home.state3');
			    } else if (hours > 18 && hours <= 24) {
			        state= this.$t('home.state4');
			    }
			    this.state = state;
			},
			commandHandler(cmd) {
        if (cmd == 'logout') {
					// 弹窗
					this.$confirm(this.$t('notification.homemessage'), this.$t('notification.title'), {
						confirmButtonText: this.$t('notification.confirm'),
						cancelButtonText: this.$t('notification.cancel'),
						type: 'warning'
					}).then(() => {
            this.getRequest("/tpa-api/admin/logout");
            // 删除用户数据
            window.localStorage.removeItem("user");
            window.localStorage.removeItem("token");
            // 清空菜单
            this.$store.commit('initRoutes', []);
            // 跳转登录页
            this.$router.replace("/");
					}).catch(() => {
						this.$message({
							type: 'info',
							message: this.$t('notification.cancelinfohome')
						});
					});
					// 
				}
        else if (cmd == 'openMyInfo') {
					//this.cardialogFormVisible = true;
					this.adminForm = {};
					this.$router.push({
						path: '/userInfo'
					})
				}
			},
			updateUserPwd(){
				let data={
					pwd: this.adminForm.password
				}
				this.postRequest('/tpa-api/admin/updateAdminPassword', data).then(resp=>{
					if(resp.code == 200){
						this.getRequest("/tpa-api/admin/logout");
						// 删除用户数据
						window.localStorage.removeItem("user");
						window.localStorage.removeItem("token");
						// 清空菜单
						this.$store.commit('initRoutes', []);
						// 跳转登录页
						this.$router.replace("/");
					}
					this.cardialogFormVisible = false;
				})
			},
			menuClick(index, indexPath) {
				/* 页面转跳到index中的路由中去 */
				this.$router.push(index);
			},
			initData(){
				this.$store.commit('setImageUrl', this.user.image);
			},
			initTotal() {
				let that = this;
				that.getRequest('/tpa-api/admin/getTotalCount/',null).then(resp =>{
					if(resp) {
						that.count = resp;
            setTimeout(() => {
              this.searchData();
            }, 500)
					}
          else{
            console.log("failed!!!!!!");
          }
				});
				that.getRequest('/tpa-api/admin/getUserAdminCarTotal/', null).then(resp => {
					if (resp) {
						that.userTotal = resp.result.userCount;
						that.adminTotal = resp.result.adminCount;
						that.carTotal = resp.result.carCount;

					}
				});
				that.getRequest('/tpa-api/admin/getUserAdminCarTotal/', null).then(resp => {
					if (resp) {
						that.userTotal = resp.result.userCount;
						that.adminTotal = resp.result.adminCount;
						that.carTotal = resp.result.carCount;
					}
				});
				
				
			},
			goHome() {
				this.initTotal();
				this.$router.push({
					path: '/home'
				})
			},
			searchData() {
        const data = this.count;
        this.date = data.map((i) => {
          return i.day;
        });
        let temp = 0;
        this.a = data.map((i) => {
          const num = parseInt(i.id);
          if (num == 1){
					temp = i.use_count;
				}
				else { 
					temp = temp + i.use_count;
				}
				return temp;
				});
				temp = 0;
				this.drawLine(); //折线图
			},
      drawLine() {
      // 基于准备好的dom，初始化echarts实例
			var dom = document.getElementById("myChart");
      let myChart = this.$echarts.init(dom);
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.$t('home.basicline.title'),
          top: "1",
          left: "40",
          textStyle: {
            fontSize: 16, //字体大小
            color: "#333", //字体颜色
            fontWeight: "500",
          },
        },
        tooltip: {
          //触发类型：坐标轴触发
          trigger: "axis", //触发类型  'item'图形触发：散点图，饼图等无类目轴的图表中使用； 'axis'坐标轴触发；'none'：什么都不触发。
          axisPointer: {
            type: "line", //默认为line，line直线，cross十字准星，shadow阴影
            lineStyle: {
              type: "dashed",
              color: "#808BA9",
            },
          },
          backgroundColor: "#fff", //也可以通过设置rgba调节背景颜色与透明度
          color: "#333",
          borderWidth: "1",
          borderColor: "#D9E1F8",
          textStyle: {
            color: "#333",
            fontSize: "12",
            lineHeight: "17",
          },
          formatter: function(arg) {
            // 自定义提示
            return (
              arg[0].name +
              "<br>" +
              '<span style="margin:0 5px 2px 0;display:inline-block;width:6px;height:6px;border-radius:5px;background-color:' +
              arg[0].color +
              ';"></span>' +
              arg[0].seriesName +
              '<span style="margin-left:10px;">' +
              arg[0].data +
              "</span>" +
              "<br>" +
              '<span style="margin:0 5px 2px 0;display:inline-block;width:6px;height:6px;border-radius:5px;background-color:' 
            );
          },
        },
        legend: {
          icon: "circle",
          itemHeight: 10, //修改icon图形大小
          textStyle: {
            fontSize: 14,
            color: "#333",
          },
          x: "left", //可设定图例在左、右、居中
          y: "top", //可设定图例在上、下、居中
          padding: [38, 0, 0, 32], //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
        },
        grid: {
          top: "85",
          left: "17",
          right: "37",
          bottom: "41",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.date,
          //使坐标轴刻度与标签对齐
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            // 改变x轴颜色
            lineStyle: {
              // color: "#D9E1F8",
              color: "#666",
              width: "1",
            },
          },
          axisLabel: {
            // 改变x轴字体颜色和大小
            formatter(val) {
              return "{a|" + `${val}` + "}";
            },
            rich: {
              a: {
                height: 40, // 设置字体行高
                color: "#666",
                fontSize: 14,
              },
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false, //y轴线消失
          },
          axisTick: {
            show: false, //y轴坐标点消失
          },
          boundaryGap: [0, 0], //有负数设置这个
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#D9E1F8",
            },
          },
          axisLabel: {
            textStyle: {
              fontSize: 14,
              color: "#92A5E3",
            },
          },
        },
        series: [
          {
            name: this.$t('home.basicline.series'),
            type: "line", //bar:柱状 line:折线图
            data: this.a,
            color: "#00C5AB",
            // symbol: "circle", //折线点设置为实心点
            symbolSize: 8, //折线点的大小
          },
        ],
      });
    
  	},
	},
};
</script>

<style>
	* {
		margin: 0px;
		padding: 0px;
	}

	html,
	body,
	#app,
	.page,
	.el-container {
		height: 100%;
	}

	.chartLine_wrap {
    width: auto;
    height: 438px;
    background: #fff;
 }

	.homeHeader {
		background-color: #2a69a8;
		display: flex;
		box-sizing: border-box;
		justify-content: space-between;
		padding: 0px 0px;
		
	}

	.breadcrumbContainer {
		cursor: pointer;
		font-size: 16px;
	}

	.homeHeader .title {
		font-size: 30px;
		color: #fff;
		margin-top: 16px;
    padding-top: 8px;
	}

    .homeHeader .logo{
      width:15%;
      height:70%;
      padding-top:10px ;
    }

	.homeHeader .lang-zh{
		margin-right: 0px;
		margin-left: 0px;
		padding-left: 0px;
		padding-right: 0px;
		font-size: 20px;
		color: #ffff;
	}

	.homeHeader .lang-en{
		margin-right: 0px;
		margin-left: 0px;
		padding-left: 0px;
		padding-right: 0px;
		font-size: 20px;
		color: #ffff;
	}

	.userInfo {
		cursor: pointer;
		margin-right: 0px;
		margin-left: 0px;
	}

	.el-dropdown-link {
		/* 文本居中 */
		display: flex;
		align-items: center;
		color: #FFFFFF;
		font-size: 20px;
		margin-top: 10px;
	}

	.el-dropdown-link img {
		width: 48px;
		height: 48px;
		display: flex;
		align-items: center;
		border-radius: 24px;
		margin-left: 15px;
		margin-top: 15px;
	}

	.el-aside {
		display: block;
		position: relative;
		overflow-y: scroll;
		height: 100%;
		background-color: #324157 !important;
	}

	.container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}

	.item {}

	.view-container {
		margin-top: 20px;
	}

	.dashboard {
		&-container {
			margin: 30px;
		}

		&-text {
			font-size: 30px;
			line-height: 46px;
		}
	}

	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 4px;
	}

	.card {
		height: 110px;
		width: 280px;
	}

	.icon {
		width: 90px;
		height: 90px;
	}

	.dashboard-text {
		text-align: center;
		font-size: 40px;
		margin-bottom: 40px;
	}

	h3 {
		color: #666666;
	}
</style>
